var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h5", { staticClass: "mb-3" }, [
      _vm._v("\n    " + _vm._s(_vm.dataComponent.name) + "\n  ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "wrap-hierarchy" }, [
      _vm.isCustom
        ? _c("img", {
            attrs: {
              src: require("@/assets/app-manager/img/dummy-custom-hierarchy.svg"),
              alt: "dummy-custom-hierarchy"
            }
          })
        : _c("img", {
            attrs: {
              src: require("@/assets/app-manager/img/dummy-hierarchy.svg"),
              alt: "dummy-custom-hierarchy"
            }
          })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-061a9ce4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-061a9ce4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dummy/DummyHierarchy.vue
// module id = null
// module chunks = 